import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";
import FrequencyCreator from './FrequencyCreator';
import DocumentFields from "./DocumentFields.jsx";
class Doc2SignDocumentForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
                title:'',
                frequencyType:'once',
                mimes:[],
                selectedMimes: [],
                instructions:'',
                selectedFields: [],
                fv:'',
                is_automatic:0,
                active:true, 
        };
        this.documentFields = React.createRef();
    } 
    handleTitleChange = (e) => {    
        this.setState({ title: e.target.value });
    } 
    updateParentState = (updatedState) => {
        this.setState(updatedState);
    }
    async componentDidMount() {
        const { lang } = this.context; 
        await this.getMimes()
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                extensions: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.necesitas_especificar_los_formatos_del_documento_antes_de_guardarlo')
                        },
                    }
                },
                title: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                        stringLength: {
                            min: 3,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_3')
                        },
                    }
                },
                size: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.peso_maximo_requerido')
                        },
                        digits: {
                            message: lang.get('messages.el_valor_debe_contener_solo_digitos')
                        },
                        stringLength: {
                            min: 1,
                            max: 4,
                            message: lang.get('messages.peso_incorrecto')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });
        this.setState({fv: fv});
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    this.save();
                }
            })
            
        })
    }
    save() {
        window.blockUI();
        
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }
        const params = JSON.stringify({
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            instructions:this.state.instructions,
            title: this.state.title,
            frequency: this.state.frequencyType,
            size: 10,
            is_automatic: this.state.is_automatic,
            cfdi_id: this.state.cfdi,
            api_method: this.state.api_method,
            mimes:[1] ,
            required: true,
            active: this.state.active,
            
            period: this.state.period,
            type_id:  2,
            displayCfdiInput:this.state.displayCfdiInput,
            template:this.state.template,
            deleteTemplate: this.state.deleteTemplate,
            dateValidationComponentId:this.state.dateValidationComponentId, 
        }) 
        this.create(params)
    }
    async create(params) {  
        const { lang } = this.context; 
        var form = document.getElementById("frm");
        var formData = new FormData(form); 
        await axios.post(
            '/api/documents', params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            if($('#template').val() != ''){
                let documentId = response.data.id;
                axios.post('/api/documents/template/'+documentId,formData).then(res=>{
                })
            }
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                  window.location.href = '/documents';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        const filteredMimes = res.data.filter(mime => mime.id !== 5); 
        this.setState({ mimes: filteredMimes }); 
    }
    handleMimeChanged = (e) => {
        const v = parseInt(e.target.value);
        if (e.target.checked) {
            this.setState(prevState => ({
                selectedMimes: [...prevState.selectedMimes, v],
            }) )
        } else {
            const selectedMimes = [...this.state.selectedMimes];
            const index = selectedMimes.indexOf(v);
            if (index > -1) {
                selectedMimes.splice(index, 1);
                this.setState({ selectedMimes: selectedMimes } );
            }
        }
    }
    handleInstructionsChange = (e) =>{
        this.setState({
            instructions: e.target.value
        });
    }
    render() {
        const { lang } = this.context; 
        return (
            <form id="frm" encType="multipart/form-data">
            <div className="card card-custom gutter-b">
                <div className="card-body">
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <div className="row justify-content-center text-left">
                                <div className="col-sm-6 form-group">
                                    <label className="text-left">{lang.get('messages.nombre')}</label>
                                    <input  onChange={this.handleTitleChange}  id="title"  type="text"  autoFocus  className="form-control form-control-solid"  name="title"  value={this.state.title}/>
                                </div>
                                <div className="col-sm-6 form-group"> 
                                <label className="text-left text-muted">Frecuencia</label>
                                <div className="d-flex ">
                                    <div className=" d-flex">
                                        <div className="col-md-6  font-size-h4 selectedRadio">
                                            <input
                                                type="radio"
                                                value="once"
                                                checked={true}  
                                                disabled={true}
                                            /> Única
                                        </div>
                                        <div className="col-md-12 font-size-h5 text-dark">
                                            <input
                                                data-toggle="modal"
                                                data-target="#modal"
                                                type="radio"
                                                value="yearly" 
                                                disabled={true}
                                            /> Recurrente
                                        </div>
                                    </div>
                                </div> 
                                </div>
                            </div> 
                        </div> 
                    </div> 
                 </div>
                <div className="text-right gap-1 mr-10 mb-10">
                    <a href="/documents" className="btn btn-lg btn-secondary">
                        {lang.get('messages.cancelar')}
                    </a>
                    <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                        {lang.get('messages.guardar')}
                    </button>
                </div> 
            </div>
            </form>
        )
    }
}

export default Doc2SignDocumentForm;

if (document.getElementById('Doc2SignDocumentForm')) {
    ReactDOM.render(<Doc2SignDocumentForm />, document.getElementById('Doc2SignDocumentForm'));
}
